// contexts/ReadOnlyDatesContext.jsx
import { createContext, useContext, useMemo, useState } from 'react';

const ReadOnlyDatesContext = createContext();

export const ReadOnlyDatesProvider = ({ children }) => {
  const [hasReadOnlyDates, setHasReadOnlyDates] = useState(false);
  const value = useMemo(() => ({
    hasReadOnlyDates,
    setHasReadOnlyDates,
  }), [hasReadOnlyDates]);

  return (
    <ReadOnlyDatesContext.Provider value={value}>
      {children}
    </ReadOnlyDatesContext.Provider>
  );
};

export const useReadOnlyDates = () => useContext(ReadOnlyDatesContext);